import { TSocialMediaWithOtherMedia } from 'src/models/general';

export const getSocialMediaColor = (
  socialMedia: TSocialMediaWithOtherMedia
) => {
  switch (socialMedia) {
    case 'twitter':
      return '#000000';
    case 'instagram':
      return '#833AB4';
    case 'youtube':
      return '#CD201F';
    case 'facebook':
      return '#1877F2';
    case 'tiktok':
      return '#051C26';
    case 'linkedin':
      return '#0077B5';
    case 'googleReview':
      return '#4285F4';
    case 'telegram':
      return '#0088CC';
    case 'whatsapp':
      return '#25D366';
    case 'onlineArticle':
    case 'onlineNews':
      return '#051C26';
    case 'onlineMedia':
    case 'broadcast':
      return '#DE9047';
    case 'print':
    case 'printMedia':
      return '#064E66';
    case 'reddit':
      return '#FF4500';
    default:
      return '#000000';
  }
};
